import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { toDMYDate } from '../../../../../_utils/convert_datetime';
import {
  Button, Table, Menu,
  Pagination, Input, Segment, Header, Loader
} from 'semantic-ui-react';
import _ from 'lodash';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import swal from 'sweetalert';

import { messageShow } from '../../../../../_utils/message';
import ModalDetail from '../../opd/_bp/ModalDetail';
import { toIDR } from '../../../../../_utils/tocurrency';


export default class BPNonSTS extends Component {
   constructor(props){
      super(props);
      this.state = {
         column: null,
         data: [],
         direction: null,
         requests:true,
         data_post:[],
         isOpen:false,
         activePage:1,
         totalPages:0,
         itemPerPage: 0,
         totalItem: 0,
         q:"",

         is_detail:false,
         data_detail:null,
         loading_detail:false,
         pageActive: 1,
      }

      this.onToggleRadio = this.onToggleRadio.bind(this);
      this.onToggleModal = this.onToggleModal.bind(this);
      this.searchBpNonSts = this.searchBpNonSts.bind(this);

      this.onCloseDetail = this.onCloseDetail.bind(this);
      this.onOpenDetail = this.onOpenDetail.bind(this);
   }

  onOpenDetail = (e, { index }) => {
    const { data } = this.state;
    this.setState({
        is_detail:true,
        data_detail:data[index],
    });
  }

  onCloseDetail = () => {
    this.setState({
        is_detail:false,
        data_detail:null
    });
  }

  onToggleModal = () => {
    this.setState({
        isOpen: !this.state.isOpen
    });
  }

  onToggleRadio = (e, el) => {

    const { data_post } = this.state;

    if(el.checked){
        if(data_post.indexOf(el.value)===-1){
          this.setState({
              data_post:[
                ...this.state.data_post,
                el.value
              ]
          })
        }
    }else if(!el.checked){
        if(data_post.indexOf(el.value)>-1){
          data_post.splice(data_post.indexOf(el.value), 1);
          this.setState({
              data_post:data_post
          })
        }
    }
  }

  handleSort = clickedColumn => () => {
    const { column, data, direction } = this.state

    if (column !== clickedColumn) {
        this.setState({
          column: clickedColumn,
          data: _.sortBy(data, [clickedColumn]),
          direction: 'ascending',
        })

        return
    }

    this.setState({
        data: data.reverse(),
        direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  componentWillMount(){
    fetch(`${BaseURLDev}/bp?status=1`,{headers})
    .then(response => {
        if (!response.ok) {
          swal('Load data gagal',  { icon:'error' })
          this.setState({requests:false, loading_detail:false, loading_edit:false});
          return Promise.reject(response.statusText);
        }
        return response.json();
    })
    .then(resJSON => {
      this.setState({
         data: resJSON.data,
         totalPages: resJSON.totalPage,
         requests: false,
         totalItem: resJSON.totalItem,
         itemPerPage: resJSON.itemPerPage,
      })
    })
    .catch(err => {
      swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
        icon: "error",
      });
      this.setState({requests:false, loading_detail:false, loading_edit:false});
    })
    //err => messageGlobal({message:"Load data gagal",option:{refresh:true},value:"/a/bp"}))
  }

  handlePaginationChange = (e, { activePage }) => {
   if (this.state.pageActive === activePage){
      return false;
   }
   this.setState({ activePage, pageActive: activePage, requests: true })
   let url = null;
   if(this.state.q!==""){
      url = `${BaseURLDev}/bp?page=${activePage}&q=${this.state.q}&status=1`
   }else{
      url = `${BaseURLDev}/bp?page=${activePage}&status=1`
   }
   fetch(url,{headers})
   .then(response => {
      if (!response.ok) {
            return Promise.reject(response.statusText);
         }
      return response.json();
   })
   .then(resJSON => {
      this.setState({
         data: resJSON.data,
         totalPages: resJSON.totalPage,
         requests: false,
         totalItem: resJSON.totalItem,
         itemPerPage: resJSON.itemPerPage,
      })
   });
  }

  searchBpNonSts(e){
    this.setState({q: e.target.value, requests: true});
    fetch(`${BaseURLDev}/bp?q=${e.target.value}&status=1`,{headers})
    .then(response => {
        if (!response.ok) {
              return Promise.reject(response.statusText);
          }
        return response.json();
    })
    .then(resJSON => {
      this.setState({
         data: resJSON.data,
         totalPages: resJSON.totalPage,
         requests: false,
         totalItem: resJSON.totalItem,
         itemPerPage: resJSON.itemPerPage,
      })
    });
  }

   render() {
      const { column, data, direction,totalPages,activePage } = this.state;
       console.log(data, 'ini bp blm sts');
      return (
         <div>

            <div>
               <Menu>
                  <Menu.Item>
                     <Header>List data BP belum di STS</Header>
                  </Menu.Item>
                  <Menu.Item position="right">
                     <Input type="text"
                        icon="search"
                        placeholder="Masukkan Nomor BP"
                        autoFocus
                        style={{width:'200px'}}
                        value={this.state.q}
                        onChange={this.searchBpNonSts}
                        />
                  </Menu.Item>
               </Menu>
               <Segment loading={(this.state.loading_edit || this.state.loading_detail || this.state.requests)}>
                  <Table size='small' sortable celled>
                     <Table.Header>
                          <Table.Row>
                              <Table.HeaderCell colSpan='8'>
                                 <Pagination activePage={activePage}
                                    onPageChange={this.handlePaginationChange}
                                    totalPages={totalPages}
                                 />
                              </Table.HeaderCell>
                          </Table.Row>
                        <Table.Row>
                           <Table.HeaderCell style={{width:"5%",textAlign:"center"}}>No.</Table.HeaderCell>
                           <Table.HeaderCell style={{width:"5%",textAlign:"center"}}>#</Table.HeaderCell>
                           {/* <Table.HeaderCell style={{width:"15%"}}>SKPD</Table.HeaderCell> */}
                           <Table.HeaderCell style={{width:"15%"}}>OPD</Table.HeaderCell>
                           <Table.HeaderCell style={{width:"15%"}} sorted={column === 'no_bukti' ? direction : null} onClick={this.handleSort('no_bukti')}>
                              Nomor
                           </Table.HeaderCell>
                           <Table.HeaderCell style={{width:"8%"}} sorted={column === 'created_at' ? direction : null} onClick={this.handleSort('created_at')}>
                              Pembuatan
                           </Table.HeaderCell>
                           <Table.HeaderCell style={{width:"8%"}}>Total Rincian</Table.HeaderCell>
                           <Table.HeaderCell>Total Nilai</Table.HeaderCell>
                           <Table.HeaderCell>Keterangan</Table.HeaderCell>
                        </Table.Row>
                     </Table.Header>
                     <Table.Body>
                        {data.length === 0 &&
                           <Table.Row>
                              <Table.Cell colSpan="8">Data tidak ditemukan</Table.Cell>
                           </Table.Row>
                        }
                        {_.map(data, (item,i) => (
                           <Table.Row key={i}>
                              <Table.Cell>{i+1+(activePage-1)*10}.</Table.Cell>
                              <Table.Cell style={{width:"5%",textAlign:"center"}}>
                                 <Button.Group size='mini'>
                                    <Button
                                       color='blue'
                                       icon='block layout'
                                       index={i}
                                       onClick={this.onOpenDetail}
                                    />
                                 </Button.Group>
                              </Table.Cell>
                              {/* <Table.Cell>{item.org_skpd.nama}</Table.Cell> */}
                              <Table.Cell>{item.org_opd.nama}</Table.Cell>
                              <Table.Cell>{item.no_bukti}</Table.Cell>
                              <Table.Cell>{toDMYDate(item.created_at)}</Table.Cell>
                              <Table.Cell>{item.total_rincian}</Table.Cell>
                              <Table.Cell>{toIDR(item.total_nilai)}</Table.Cell>
                              <Table.Cell>{item.uraian}</Table.Cell>
                           </Table.Row>
                        ))}
                     </Table.Body>
                     <Table.Footer fullWidth>
                        <Table.Row>
                           <Table.HeaderCell colSpan='8'>
                              <Pagination activePage={activePage}
                                 onPageChange={this.handlePaginationChange}
                                 totalPages={totalPages}
                              />
                           </Table.HeaderCell>
                        </Table.Row>
                     </Table.Footer>
                  </Table>
               </Segment>
               {this.state.is_detail &&
                  <ModalDetail
                     open={this.state.is_detail}
                     data_detail={this.state.data_detail}
                     onClose={this.onCloseDetail} />
               }

          </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_bp/BPNonSTS.js